import { createFileRoute } from '@tanstack/react-router';

import { clientModules } from '@/clientModules';

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>) => ({
    redirectTo: (search.redirectTo as string | undefined) || undefined
  }),
  component: LoginPage
});

function LoginPage() {
  return <clientModules.authentication.LoginPage />;
}
